(() => {
  function init(root) {
    const dialog = root.querySelector('dialog.ea-welcome');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    const form = dialog.querySelector('form');
    const email = form.elements['contact[email]'];
    const consent = form.querySelector('[type=checkbox]');
    const message = dialog.querySelector('[data-message]');
    const signup = dialog.querySelector('[data-signup]');
    const success = dialog.querySelector('[data-success]');
    const code = dialog.querySelector('[data-code]').textContent.trim();
    const key = 'ea.welcome.' + code + '.' + dialog.dataset.expiry;
    function session(suffix, value) {
      try {
        if (value === undefined) return sessionStorage.getItem(key + suffix);
        if (value === null) sessionStorage.removeItem(key + suffix);
        else sessionStorage.setItem(key + suffix, value);
      } catch { /* The native form can still return to its anchor. */ }
    }
    const end = Date.parse(dialog.dataset.expiry + 'T23:59:59.999+04:00');
    const active = () => Number.isFinite(end) && Date.now() <= end;
    const open = () => {
      if (active() && dialog.isConnected && !dialog.open) {
        dialog.showModal();
        dialog.querySelector('h2').focus();
      }
    };
    if (!active()) return;
    const pending = session('.pending');
    const returned = location.hash === '#welcome-popup-form' || Boolean(pending);
    const result = dialog.querySelector('[data-result]').dataset.result;
    session('.pending', null);
    const duplicate = () => {
      signup.hidden = true;
      success.hidden = true;
      message.textContent = dialog.dataset.member;
      message.hidden = false;
    };
    if (returned && (result === 'error' || result === 'success' || new URLSearchParams(location.search).get('customer_posted') === 'true')) {
      if (dialog.hasAttribute('data-subscriber')) duplicate();
      else if (result === 'error') message.hidden = false;
      else {
        signup.hidden = true;
        success.hidden = false;
        session('.seen', '1');
        if (pending && pending !== 'submitted') {
          try { localStorage.setItem(key + '.used.' + pending, '1'); } catch {}
        }
      }
      open();
    } else if (window.Shopify?.designMode || (!session('.seen') && !dialog.hasAttribute('data-subscriber'))) {
      setTimeout(open, Number(dialog.dataset.delay) * 1000);
    }
    dialog.querySelector('.ea-welcome__close').onclick = () => dialog.close();
    dialog.addEventListener('close', () => session('.seen', '1'));
    for (const input of [email, consent]) {
      input.addEventListener('invalid', () => input.setCustomValidity(input === email ? dialog.dataset.invalid : dialog.dataset.required));
      input.addEventListener('input', () => input.setCustomValidity(''));
    }
    let resuming = false;
    form.addEventListener('submit', async event => {
      if (!active()) { event.preventDefault(); dialog.close(); return; }
      if (resuming) return;
      event.preventDefault();
      const button = form.querySelector('[type=submit]');
      if (button.disabled) return;
      button.disabled = true;
      let fingerprint = 'submitted';
      try {
        const data = new TextEncoder().encode(email.value.trim().toLowerCase());
        const digest = await crypto.subtle.digest('SHA-256', data);
        fingerprint = Array.from(new Uint8Array(digest), n => n.toString(16).padStart(2, '0')).join('');
        if (localStorage.getItem(key + '.used.' + fingerprint)) { duplicate(); return; }
      } catch { /* Storage and Web Crypto are optional. */ }
      finally { button.disabled = false; }
      session('.pending', fingerprint);
      resuming = true;
      form.requestSubmit(button);
      resuming = false;
    });
    dialog.querySelector('[data-copy]').onclick = async () => {
      const selected = window.getSelection();
      const status = dialog.querySelector('[data-copy-status]');
      try { await navigator.clipboard.writeText(code); status.textContent = dialog.dataset.copied; }
      catch {
        const range = document.createRange();
        range.selectNodeContents(dialog.querySelector('[data-code]'));
        selected.removeAllRanges(); selected.addRange(range);
        status.textContent = document.execCommand('copy') ? dialog.dataset.copied : dialog.dataset.manual;
      }
    };
  }
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
